import { JSONValue } from "@smile2impress/attraction-constants";
import { useRouter } from "next/router";
import { useUTSLocaleContext } from "context/utsLocaleContext";
import { getLocalizedPathname } from "modules/localize-pathnames/getLocalizedPathname";

import { UTSLocaleToI18nLocale } from "constants/enum";
import { UrlsConfig } from "configs/urlsConfig";

import { JSONSchemaServiceBlogContent } from "../JSONSchemaService.types";

export const BlogJSONSchema = (
    content: JSONSchemaServiceBlogContent
): JSONValue => {
    const {
        datePublished,
        dateModified,
        imageUrl,
        title,
        description,
        pageUrl,
    } = content;

    const { locale } = useUTSLocaleContext();
    const { locale: routerLocale } = useRouter();

    return {
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": pageUrl,
        },
        headline: title,
        description: description,
        image: imageUrl,
        author: {
            "@type": "Organization",
            name: "Impress",
            url: `${
                UrlsConfig.HOME_PAGE_URL
            }/${routerLocale}${getLocalizedPathname(
                UrlsConfig.WHY_IMPRESS,
                UTSLocaleToI18nLocale[locale],
                true
            )}`,
        },
        publisher: {
            "@type": "Organization",
            name: "Impress",
        },
        datePublished: datePublished,
        ...(dateModified ? { dateModified } : {}),
    } as JSONValue;
};
